import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { LanguageService } from '../../shared/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from '../../shared/services/account.service';
import { BasketService } from '../../shared/services/basket.service';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser';
declare var Swal:any;

@Component({
  selector: 'app-senar',
  templateUrl: './senar.component.html',
  styleUrls: ['./senar.component.scss']
})
export class SenarComponent implements OnInit {

  public certifications = [
      {
          src : "assets/logos-senar/honeywell",
          width : "108px",
          alt: "Logo of Honeywell",
          title:"Honeywell",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/rio-tinto",
          width : "86px",
          alt: "Logo of Rio Tinto",
          title:"Rio Tinto",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/schneider-electric",
          width : "95px",
          alt: "Logo of Schneider Electric",
          title:"Schneider Electric",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/aramco",
          width : "105px",
          alt: "Logo of Aramco",
          title:"Aramco",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/engie",
          width : "75px",
          alt: "Logo of Engie",
          title:"Engie",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/bouygues-energies-services",
          width : "83px",
          alt: "Logo of Bouygues energies services",
          title:"Bouygues",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/hermes-paris",
          width : "70px",
          alt: "Logo of Hermes Paris",
          title:"Hermes Paris",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/bureau-veritas",
          width : "40px",
          alt: "Logo of Bureau Veritas",
          title:"Bureau Veritas",
          isSVG: true,
      },
      {
          src : "assets/logos-senar/equans",
          width : "110px",
          alt: "Logo of Equans",
          title:"Equans",
          isSVG: true,
      }
  ]
  public prices:any = {}
  public loading = true
  public videoUrl = "https://www.youtube.com/embed/1e4qaIGtHNs"
  public currentLang
  public IosUrl
  public AndroidUrl

  constructor(
    public language : LanguageService,
    public translate: TranslateService,
    public router : Router,
    public activatedRoute: ActivatedRoute,
    private accountService : AccountService,
    public basketService : BasketService,
    public sanitizer:DomSanitizer,
    @Inject(DOCUMENT) public document: Document
  ) {}

  public videoSrc : SafeResourceUrl;

  ngOnInit() {
      this.getCurrentLang()
      this.refreshPrices()

      return this.basketService.getPrices()
      .then((prices)=>{
          this.prices = prices
          // console.log(prices)
      })

      if(isBrowser() && $('video') && $('video').length){
          for (let i = 0; i<$('video').length; i++) {
              $('video')[i].muted = true;
              $('video')[i].load();
          }
      }
      this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl("");
  }

  video(){
    const url = this.videoUrl;
    this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url+"?autoplay=1&amp;modestbranding=1&amp;showinfo=0");

    var modal = document.querySelector(".modal");
    var container = modal.querySelector(".modal-content");

    // Check if we click outside the modal in order to stop the video
    document.querySelector(".modal").addEventListener("click", function (e) {
      if (e.target !== container){
        document.getElementById("video").setAttribute('src', '');
      }
    });
  }

  scrollToAnchor(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }


  refreshPrices(){
      this.loading = true
      return this.basketService.getPrices()
      .then((prices)=>{
          this.loading = false
          this.prices = prices
      })
  }

  getCurrentLang(){
      this.currentLang = this.translate.store.currentLang;
      if (this.currentLang == 'en') {
        this.IosUrl = "https://apps.apple.com/us/app/senar/id1464123633"
        this.AndroidUrl = "https://play.google.com/store/apps/details?id=com.guidigo.ar.senario&hl=en_US"
      } else {
        this.IosUrl = "https://apps.apple.com/fr/app/senar/id1464123633"
        this.AndroidUrl = "https://play.google.com/store/apps/details?id=com.guidigo.ar.senario"
      }
  }

}
